import { useOfflineFirstQuery } from '../../../hooks/useOfflineFirstQuery'
import { apiClient } from '../../../api/client'

type Payment = {
  id: string
  amount: string
  payment_date: string
  payment_type: string
  claim_id: string
}

export default function PaymentsListPage() {
  const { data, isFetching, error, refetch } = useOfflineFirstQuery<Payment[]>({
    queryKey: ['payments'],
    cacheKey: 'payments:list',
    staleTime: 1000 * 60,
    queryFn: async () => {
      const res = await apiClient.get('/api/v1/billing/payments/')
      return res.data as Payment[]
    },
  })

  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between">
        <h1 className="text-xl font-semibold text-gray-900">Payments</h1>
        <button
          onClick={() => refetch()}
          className="rounded-md border border-gray-200 px-3 py-2 text-sm text-gray-700 hover:bg-gray-50"
        >
          Refresh
        </button>
      </div>

      {error && (
        <div className="rounded-md border border-red-200 bg-red-50 px-3 py-2 text-sm text-red-800">
          {(error as Error).message}
        </div>
      )}

      <div className="overflow-hidden rounded-lg border border-gray-200 bg-white">
        <table className="min-w-full divide-y divide-gray-200">
          <thead className="bg-gray-50">
            <tr>
              <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase">Date</th>
              <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase">Amount</th>
              <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase">Method</th>
              <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase">Claim</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-200 bg-white">
            {isFetching && (
              <tr>
                <td colSpan={4} className="px-4 py-4 text-center text-sm text-gray-500">
                  Loading…
                </td>
              </tr>
            )}
            {data?.map((p) => (
              <tr key={p.id}>
                <td className="px-4 py-3 text-sm text-gray-700">{p.payment_date}</td>
                <td className="px-4 py-3 text-sm text-gray-900">{p.amount}</td>
                <td className="px-4 py-3 text-sm text-gray-700">{p.payment_type}</td>
                <td className="px-4 py-3 text-sm text-gray-700">{p.claim_id}</td>
              </tr>
            ))}
            {!isFetching && (!data || data.length === 0) && (
              <tr>
                <td colSpan={4} className="px-4 py-4 text-center text-sm text-gray-500">
                  No payments recorded.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  )
}
